import { combineReducers } from 'redux';
import pages, { actions as pagesActions } from './pages';
import schedule, { actions as scheduleActions } from './schedule';
import messages, { actions as messagesActions } from './messages';
import create, {
  actions as createActions,
  selectors as createSelectors
} from './create';
import collections, {
  actions as collectionsActions,
  selectors as collectionsSelectors
} from './collections';
import auth, {
  actions as authActions,
  selectors as authSelectors
} from './auth';

export const selectors = {
  create: createSelectors,
  collections: collectionsSelectors,
  auth: authSelectors
};

export const actions = {
  pages: pagesActions,
  schedule: scheduleActions,
  create: createActions,
  collections: collectionsActions,
  auth: authActions,
  messages: messagesActions
};

export default combineReducers({
  pages,
  schedule,
  create,
  collections,
  auth,
  messages
});



// WEBPACK FOOTER //
// ./src/reducers/index.js